module.exports = __webpack_public_path__ + "static/img/view.7a2229a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/view.png
// module id = 4/wA
// module chunks = 0